<div class="global-nav-container">
  <div class="logo"></div>
  <span class="welcome-title" *ngIf="onAdmin()">User Admin</span>
  <div class="application-selector" *ngIf="onAdmin()">
    <mat-select
      data-cy="application"
      (selectionChange)="navigateToApplication($event)"
      [placeholder]="'Go To Application'"
    >
      @for (application of applications; track application) {
        <mat-option [value]="application">{{ application.displayLabel }}</mat-option>
      }
    </mat-select>
  </div>
  <div class="logout" *ngIf="onAdmin()">
    <button class="x-btn x-btn-primary" (click)="logout()">Logout</button>
  </div>
</div>

<login-global-alert></login-global-alert>

<div class="router-container">
  <router-outlet></router-outlet>
</div>
